import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './Navigation';
import { Languages, Mic, PlayCircle } from 'lucide-react';
import {useNavigate} from "react-router-dom";

export const Hero: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div id="hero" className="pt-24 pb-16 md:pt-32 md:pb-24 bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6">
            {t('hero.title')}{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 to-yellow-400">
              {t('hero.titleHighlight')}
            </span>
          </h1>
          <p className="text-xl text-indigo-100 mb-8 max-w-2xl">
            {t('hero.description')}
          </p>
          <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 mb-12">
            <Button
                primary
                className="bg-white text-indigo-600 hover:bg-indigo-50 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all"
                onClick={() => navigate('/login')}
            >
              {t('hero.startTrial')}
            </Button>
            {/*<Button className="bg-white/10 backdrop-blur-sm border-2 border-white/20 text-white hover:bg-white/20 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all flex items-center justify-center">*/}
            {/*  <PlayCircle className="mr-2 h-5 w-5" />*/}
            {/*  {t('hero.watchDemo')}*/}
            {/*</Button>*/}
          </div>
          <div className="flex items-center justify-center space-x-8 text-sm">
            <div className="flex items-center">
              <Mic className="h-5 w-5 mr-2" />
              <span>{t('hero.liveSermon')}</span>
            </div>
            <div className="flex items-center">
              <Languages className="h-5 w-5 mr-2" />
              <span>{t('hero.languages')}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
